import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { CookieService } from '../Services/cookie';
import { Subject } from "rxjs";



@Component({
  selector: "app-type-of-product",
  templateUrl: "./type-of-product.component.html",
  standalone:false,
  styleUrls: ["./type-of-product.component.scss"],
})
export class TypeOfProductComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  UpdateEmail: string = "";
  IDNo: string = "";

  constructor(private router: Router,    private cookieService: CookieService,
    ) {}

  ngOnInit(): void {}

  quickpay(v) {

  
    this.cookieService.set("prodType", v,true);

    localStorage.setItem('Product', v);
    this.router.navigateByUrl("/QuickPayment");
  }
}
